import {
  Flex, Select, Text,
} from '@chakra-ui/react';
import ColorPicker from '../ColorPicker/ColorPicker';
import InputSetting from '../InputSetting';
import { buildPalette } from '../../helpers';

const borderStyleOptions = [
  { key: 'none', value: 'None' },
  { key: 'solid', value: 'Solid' },
  { key: 'dotted', value: 'Dotted' },
  { key: 'dashed', value: 'Dashed' },
  { key: 'inset', value: 'Inset' },
];

const BorderSytles = ({
  borderColor, borderStyle, borderWidth, onChange,
}) => {
  const handleChangeColor = (color) => {
    const palette = buildPalette(color);
    onChange({
      borderColor: color,
      hover: {
        borderColor: palette['600'],
      },
      focus: {
        borderColor: palette['700'],
      },
    });
  };

  return (
    <>
      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Border</Text>
        <ColorPicker
          color={borderColor}
          onChange={handleChangeColor}
        />
      </Flex>
      <Flex justify="space-between" w="100%" alignItems="center">
        <Text>Border style</Text>
        <Select
          value={borderStyle}
          onChange={(e) => onChange({ borderStyle: e.target.value })}
          w="unset"
        >
          {borderStyleOptions.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
        </Select>
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Border width"
          value={borderWidth}
          onChange={(v) => onChange({ borderWidth: v })}
          regex={/^[0-9]+ ?px$/}
          errorMessage="Width must be in px"
        />
      </Flex>
    </>
  );
};

export default BorderSytles;
